import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackgroundImageComponent } from 'app/core/background-image/background-image.component';
import { FooterComponent } from 'app/core/footer/footer.component';
import { NavBarComponent } from 'app/core/nav-bar/nav-bar.component';
import { ProfileComponent } from 'app/core/profile/profile.component';
import { ToolbarComponent } from 'app/core/toolbar/toolbar.component';
import { LoginComponent } from 'app/core/security/login.component';
import { LogonComponent } from 'app/core/security/logon.component';
import { LogonConfirmedComponent } from 'app/core/security/logonConfirmed.component';
import { LogoutComponent } from 'app/core/security/logout.component';
import { FormsModule } from '@angular/forms';
import { AuthService } from 'app/core/security/auth.service';
import { BsDropdownModule, AlertModule, AccordionModule, PopoverModule } from 'ngx-bootstrap';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from 'app/core/security/route-guards.service';
import { MapLayer } from 'app/shared/data/map-layer';


const routes: Routes = [
  //{ path: 'profile',  component: ProfileComponent, canActivate: [AuthGuardService]  },
  //{ path: 'home',     component: AppHomeComponent },
  //{ path: 'aide',     component: AideComponent },
  { path: 'login',    component: LoginComponent },
  { path: 'logon',    component: LogonComponent },
  { path: 'logonConfirmed',    component: LogonConfirmedComponent },
  { path: 'logout',   component: LogoutComponent }
]

@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    // Bootstrap
    RouterModule.forChild(routes),
    AlertModule.forRoot(),
    AccordionModule.forRoot(),
    PopoverModule.forRoot(),
    BsDropdownModule.forRoot(),
  ],
  declarations: [
    BackgroundImageComponent,
    FooterComponent,
    NavBarComponent,
    ProfileComponent,
    ToolbarComponent,
    LoginComponent,
    LogonComponent,
    LogonConfirmedComponent,
    LogoutComponent

    // Bootstrap
  ],
  exports: [
    BackgroundImageComponent,
    FooterComponent,
    NavBarComponent,
    ProfileComponent,
    ToolbarComponent
  ],
  providers: [
    AuthService
  ],
  bootstrap: [
    //AuthService
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/core.module.ts